import classNames from "classnames";
import React from "react";

import useCheckDevice from "@repo/shopifyV2/hooks/useCheckDevice";
import useScrollLock from "@repo/shopifyV2/hooks/useScrollLock";
import type { Menu } from "@repo/shopifyV2/types/storefront.types";

import Link from "@atoms/Link";

import useCheckLocation from "@hooks/useCheckLocation";
import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

interface IProps {
  menu: Menu | undefined;
}

export default function HeaderNavigation({ menu }: IProps) {
  const { domain, shopifyDomain } = useLanguage();

  const { openNavigation } = useLayoutStore();

  const { isDanielJohnston } = useCheckLocation();

  const { isPC } = useCheckDevice();

  useScrollLock();

  return (
    <>
      {isPC ? (
        <div className={classNames("fixed top-12 left-0 h-dvh w-dvw bg-white", isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black")} />
      ) : null}
      <div
        className={classNames(
          "scrollbar-hide pc:absolute pc:top-full pc:h-[calc(100vh-3.75rem)] pc:w-auto pc:px-0 pc:pt-0 pc:-left-4 fixed top-0 left-0 z-30 h-dvh w-full overflow-y-scroll bg-white px-4 pt-12.5 dark:text-white",
          isDanielJohnston ? "dark:bg-dj-black" : "dark:bg-black",
        )}
      >
        <div
          className="pc:w-screen-col-span-2 pc:grid-cols-2 pc:pb-20 pc:gap-y-2.5 pc:pl-4 grid h-fit auto-rows-min grid-cols-8 gap-y-3.5 pt-4 pb-4"
          onMouseEnter={() => {
            openNavigation(true);
          }}
          onMouseLeave={() => {
            openNavigation(false);
          }}
        >
          <div className="pc:col-start-1 pc:gap-5 col-span-8 col-start-2 flex flex-col gap-7.5">
            {menu?.items.map((item) => (
              <div className="pc:gap-2 flex flex-col gap-3.5" key={item.id}>
                {item.items.map((menuItem) => (
                  <Link
                    as="text"
                    className={classNames("pc:col-span-1 col-span-5 w-fit leading-none", !isPC && "text-base!")}
                    href={menuItem.url?.replace(domain, "").replace(shopifyDomain, "")}
                    key={menuItem.id}
                    onClick={() => {
                      openNavigation(false);
                    }}
                  >
                    {menuItem.title}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
